// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const NotificationTooltip: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 13"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M6 .5a6 6 0 100 12 6 6 0 100-12zm0 9.375a.74.74 0 01-.75-.75c0-.422.307-.75.75-.75.4 0 .75.328.75.75s-.35.75-.75.75zm1.62-3.328l-1.058.656v.047A.57.57 0 016 7.813a.57.57 0 01-.563-.563v-.375c0-.188.094-.375.282-.492l1.336-.797a.503.503 0 00.258-.445c0-.282-.256-.516-.537-.516H5.578a.507.507 0 00-.516.516.57.57 0 01-.562.562.57.57 0 01-.563-.562c0-.914.727-1.641 1.62-1.641h1.198c.956 0 1.683.727 1.683 1.64 0 .563-.305 1.102-.818 1.407z"/></svg>;
};

export default React.memo(NotificationTooltip);
